import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import draggable from 'vuedraggable';
import store from '@/store';

import LayersTreeItem from './item/LayersTreeItem.vue';
import CLazy from '@/components/CLazy.vue';
import { useLayersDraggable } from '@/components/Layers/composables/layerDraggable';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersTree',
  emits: ["tree-item-moved"],
  setup(__props, { emit }: { emit: ({
    (event: 'tree-item-moved'): void;
}), expose: any, slots: any, attrs: any }) {

const { dragOptions, handleMove, getItemKey, handleChange } = useLayersDraggable();



const treeItems = computed({
    get: () => store.state.storeLayers?.treeItems || [],
    set: (value) => store.dispatch('storeLayers/setTreeItems', value)
});

const onChange = () => {
    handleChange();
};

const layerTreeItemMove = () => {
    emit('tree-item-moved');
};

return { __sfc: true,dragOptions, handleMove, getItemKey, handleChange, emit, treeItems, onChange, layerTreeItemMove, draggable, LayersTreeItem, CLazy }
}

})